import RadioOffIcon from 'components/elements/icons/RadioOffIcon'
import RadioOnIcon from 'components/elements/icons/RadioOnIcon'
import React from 'react'

/**
 * ラジオシンボル
 */
const RadioSymbol: React.FC<RadioSymbolProps> = (props) => {
  const RadioIcon = props.isSelected ? RadioOnIcon : RadioOffIcon
  return <RadioIcon width={props.width} height={props.height} />
}

export type RadioSymbolProps = {
  isSelected: boolean
  width?: string
  height?: string
}

export default RadioSymbol
